<ng-container *ngIf="herstellerIsLoaded">
  <ng-container *ngIf="inSucces">
    <div class="ols-break">
      <div class="ols-break-sluit"></div>
      <div class="ols-break-open"></div>
    </div>
    <div class="ols-gh-man"></div>
    <div class="ols-title ols-gh-title"><app-sharedtekst [key]="'woonglas_anderehersteller_titel'"></app-sharedtekst></div>
    <div><app-sharedtekst [key]="'woonglas_anderehersteller_subtitel'"></app-sharedtekst></div>
  </ng-container>

  <div *ngIf="!inSucces" class="ols-title ols-gh-title">{{vraagtitel}}</div>
  <div *ngFor="let regel of vraag.vraagregels" [innerHTML]="regel"></div>

  <div class="ols-gh">
    <div class="ols-gh-icon"></div>
    <div class="ols-gh-contact">
      <div class="ols-gh-naam">{{naam}}</div>
      <div class="ols-gh-telnr"><a href="tel:{{telnrFormatted}}">{{telnr}}</a></div>
    </div>
  </div>

  <ng-container *ngFor="let antw of vraag.antwoorden">
    <div class="ols-gh-head" [innerHTML]="replaceNaam(antw.titel)"></div>
    <ul class="ols-ml">
      <li *ngFor="let regel of antw.antwoordregels" [innerHTML]="regel"></li>
    </ul>
  </ng-container>

  <ng-container *ngIf="!inSucces">
    <div class="ols-break">
      <div class="ols-break-sluit"></div>
      <div class="ols-break-open"></div>
    </div>
  
    <div class="ols-ietje">
      <div class="icon-verz ial-al_017"></div>
      <div class="ols-title ols-gh-title"><app-sharedtekst [key]="'belangrijk'"></app-sharedtekst></div>
      <ul class="ols-ml">
        <li *ngFor="let tekst of belangrijk" [innerHTML]="tekst"></li>
      </ul>
    </div>
  </ng-container>
</ng-container>
<app-fake-content-section *ngIf="!herstellerIsLoaded" [rowCount]="10"></app-fake-content-section>

